import { createLang } from "@bitcart/vike-kit/metadata"

export default createLang()
